import {useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';

import {queryInvalidateKeys} from '../apiQueryOptions';

export const useQueryInvalidator = <
  T extends keyof typeof queryInvalidateKeys
>(
    invalidateKeyName: T,
    action: 'invalidate' | 'remove',
    ...args: Parameters<typeof queryInvalidateKeys[T]>
  ) => {
  const queryClient = useQueryClient();
  const keyGenFn = queryInvalidateKeys[invalidateKeyName];
  return useCallback(
    () => action === 'invalidate' ?
      queryClient.invalidateQueries({
        // @ts-expect-error: args is parameters of fn, but there is a TS error that it should be a tuple
        queryKey: keyGenFn(...args),
      }) :
      queryClient.removeQueries({
        // @ts-expect-error: args is parameters of fn, but there is a TS error that it should be a tuple
        queryKey: keyGenFn(...args),
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invalidateKeyName, queryClient, ...args]
  );
};
